import script from "./AuthMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthMenu.vue?vue&type=script&setup=true&lang=js"

import "./AuthMenu.vue?vue&type=style&index=0&id=d27bd67a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d27bd67a"]])

export default __exports__